import { authFetch } from '@flexibilitypay/shared';

/**
 * (Backfill automático — agregar descripción)
 *
 * @taskId T059a
 * @taskId T059b
 * @see functional/Specs/specs_cycle-2.md HU-07-FE
 */
export interface MovementItem {
  id: number;
  idWeb: string;
  fechaOperacion: string;
  tipoTransaccion: string;
  moneda: string;
  importe: number;
  descripcion: string;
  estado: string;
  idWebEstado: string;
  idCoelsa: string;
  acreditaSaldoCuenta: boolean;
}

export interface MovementsPaginationMeta {
  TotalRecords: number;
  TotalPages: number;
  CurrentPageRecordCount: number;
}

export interface MovementsPage {
  items: MovementItem[];
  pagination: MovementsPaginationMeta | null;
}

export interface FetchMovementsParams {
  idCuenta: string;
  skip?: number;
  top?: number;
  from?: string;
  to?: string;
}

function buildQuery(params: FetchMovementsParams): string {
  const search = new URLSearchParams();
  search.set('$IdUsuarioLineaCuenta', params.idCuenta);
  if (params.skip !== undefined) search.set('$skip', String(params.skip));
  if (params.top !== undefined) search.set('$top', String(params.top));
  if (params.from) search.set('$from', params.from);
  if (params.to) search.set('$to', params.to);
  return search.toString();
}

function parsePagination(header: string | null): MovementsPaginationMeta | null {
  if (!header) return null;
  try {
    const parsed = JSON.parse(header) as Partial<MovementsPaginationMeta>;
    if (
      typeof parsed.TotalRecords === 'number' &&
      typeof parsed.TotalPages === 'number' &&
      typeof parsed.CurrentPageRecordCount === 'number'
    ) {
      return parsed as MovementsPaginationMeta;
    }
    return null;
  } catch {
    return null;
  }
}

export async function fetchMovements(
  params: FetchMovementsParams,
): Promise<MovementsPage> {
  const response = await authFetch(`/Transacciones?${buildQuery(params)}`);
  if (!response.ok) {
    throw new Error(`HTTP_${response.status}`);
  }
  const items = (await response.json()) as MovementItem[];
  const pagination = parsePagination(response.headers.get('X-Pagination'));
  return { items, pagination };
}
